import { Component, OnInit } from '@angular/core'
import { UiService } from 'src/app/services/ui.service'

@Component({
  selector: 'app-create-account-panel-shell',
  templateUrl: './create-account-panel-shell.component.html',
  styleUrls: ['./create-account-panel-shell.component.scss'],
  standalone: false,
})
export class CreateAccountPanelShellComponent implements OnInit {
  constructor(public uiService: UiService) {}

  ngOnInit() {}
}
